import type { Condition, CountCondition, Operator } from 'src/store/selectors/conditional/conditional';

function checkSingle(valueA: any, operator: Operator, valueB: any) {
  if (operator === 'EQUALS') {
    return valueA === valueB;
  }
  if (operator === 'NOT_EQUALS') {
    return valueA !== valueB;
  }
  if (operator === 'LESS_THAN') {
    return valueA < valueB;
  }
  if (operator === 'GREATER_THAN') {
    return valueA > valueB;
  }
  if (operator === 'HAS') {
    return valueA.includes(valueB);
  }
  if (operator === 'NOT_HAS') {
    return !valueA.includes(valueB);
  }
}

function checkCount(entity: any, condition: CountCondition, itemUuid: string | undefined = undefined) {
  if (!entity[condition.list]) {
    return true;
  }
  let items = entity[condition.list];
  if (!items) {
    items = [];
  }
  if (condition.condition) {
    items = items.filter((item: any) => {
      return condition.condition && checkCondition(item, condition.condition, undefined, condition.list, itemUuid);
    });
  }
  return checkSingle(items.length, condition.operator, condition.value);
}

export function checkCondition(
  entity: any,
  condition: Condition,
  context: string | undefined,
  list: string | undefined = undefined,
  itemUuid: string | undefined = undefined,
) {
  if (condition.type === 'SINGLE') {
    let property = condition.property;
    let value = condition.value;
    if (condition.isContextProperty && context) {
      const entities = entity[context];
      if (itemUuid) {
        entity = entities.find((o) => {
          return o.uuid === itemUuid;
        });
      }
    }
    if (property === 'systemVersion') {
      property = 'singleUser';
      value = value === 'singleUser';
    }
    const fieldValue = entity[property];
    if (value === 'contextEntityUuid' && itemUuid) {
      value = itemUuid;
    }
    return checkSingle(fieldValue, condition.operator, value);
  }
  if (condition.type === 'COUNT') {
    return checkCount(entity, condition, itemUuid);
  }
  let result = true;
  if (condition.type === 'AND') {
    condition.conditions.forEach((c) => {
      if (!checkCondition(entity, c, context, list, itemUuid)) {
        result = false;
      }
    });
  }
  if (condition.type === 'OR') {
    result = false;
    condition.conditions.forEach((c) => {
      if (checkCondition(entity, c, context, list, itemUuid)) {
        result = true;
      }
    });
  }
  return result;
}
